module.exports = __webpack_public_path__ + "assets/img/qualityS.465e7352.jpg";